<template>
  <div class="animated fadeIn">
   <b-modal ref="modal-phone" scrollable centered button-size="sm">
     <template #modal-title>
       <i class="fas fa-phone-volume"></i> NOVO CONTATO
     </template>
     <div class="pb-4">
       <div class="form-group row pt-2">
         <div class="col-md-12">
           <label for="txtGroup"><small class="text-danger" v-if="form.tipoContato.required">*</small> Tipo Contatos:</label>
           <div class="input-group">
             <span class="input-group-addon"><i class="fas fa-bullhorn"></i></span>
             <b-form-select v-model="form.tipoContato.value" :options="form.tipoContato.options">
               <template slot="first">
                 <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                 <option value="0">CELULAR</option>
                 <option value="1">COMERCIAL</option>
                 <option value="2">RESIDENCIAL</option>
               </template>
             </b-form-select>
           </div>
         </div>
       </div>
       <div class="form-group row pt-2" v-if="form.tipoContato.value && form.tipoContato.value > 0">
         <div class="col-md-12">
           <label><small class="text-danger" v-if="form.telefone.required">*</small> Telefone:</label>
           <div class="input-group">
             <span class="input-group-addon"><i class="fas fa-phone-alt"></i></span>
             <b-form-input type="text"
                           :placeholder="$lang.Common.PhonePlaceholder"
                           v-model="form.telefone.value"
                           :size="form.telefone.maxlength"
                           :required="form.telefone.required"
                           :state="form.telefone.state"
                           v-mask="['(##) ####-####']"></b-form-input>
           </div>
         </div>
       </div>
       <div class="form-group row pt-2" v-else>
         <div class="col-md-12">
           <label><small class="text-danger" v-if="form.telefone.required">*</small> Celular:</label>
           <div class="input-group">
             <span class="input-group-addon"><i class="fas fa-mobile"></i></span>
             <b-form-input type="text"
                           :placeholder="$lang.Common.MobilePhonePlaceholder"
                           v-model="form.telefone.value"
                           :size="form.telefone.maxlength"
                           :required="form.telefone.required"
                           :state="form.telefone.state"
                           v-mask="['(##) # ####-####']"></b-form-input>
           </div>
         </div>
       </div>
     </div>
     <template #modal-footer>
       <div class="w-100 text-right">
         <button @click.prevent="onSave" type="button" class="btn btn-third btn-sm"  v-b-tooltip.hover :title="'Salvar'"><i class="fas fa-check-circle"></i><span class="d-md-down-none"> Salvar</span></button>
       </div>
     </template>
   </b-modal>
  </div>
</template>
<script>
import PhoneModal from './phonemodal.js'
export default PhoneModal
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/phones/modal/phonemodal.vue